export enum CategoryEnum {
    ALL = '',
    PLOT = 'PLOT',
    RESIDENTIAL = 'RESIDENTIAL',
    COMMERCIAL = 'COMMERCIAL',
}
